import { type HttpClientConfig } from '../../infra/http/HttpClient'
import { type ChatContactInfo } from '../domain/Chat'
import { ChatRepository } from '../infra/ChatRepository'
import { createChatHttpClient } from '../infra/createChatHttpClient'

export type GetChatsListRepositoryParams = {
  repository: ChatRepository
}

export function getUserContactInfo(config?: Partial<HttpClientConfig>): Promise<ChatContactInfo> {
  const httpClient = createChatHttpClient()
  const repository = new ChatRepository({ httpClient })

  return repository.getUserContactInfo(config)
}
